import React, { createRef, useState } from "react";
import { Info } from "../sections/info";
import { Intro } from "../sections/intro";
import { Map } from "../sections/map";
import { Details } from "../sections/details";
import styles from "./index.module.scss";
import wave1 from "./wave1.svg";
import wave2 from "./wave2.svg";
import wave3 from "./wave3.svg";
import music from "../music/orange.mp3";
var Main = function () {
    return React.createElement(React.Fragment, null,
        React.createElement(Intro, null),
        React.createElement("img", { src: wave1, className: styles.wave }),
        React.createElement(Info, null),
        React.createElement("img", { src: wave2, className: styles.wave }),
        React.createElement(Map, null),
        React.createElement("img", { src: wave3, className: styles.wave }),
        React.createElement(Details, null));
};
var Start = function (props) {
    return React.createElement("div", { className: styles.start },
        React.createElement("button", { onClick: function () {
                var cur = props.audio.current;
                if (cur === null)
                    return;
                cur.play();
                props.onStart();
            } }, "D\u00E9couvrir"));
};
export var App = function () {
    var audio = createRef();
    var _a = useState(false), playing = _a[0], setPlaying = _a[1];
    return React.createElement("div", { className: styles.container },
        React.createElement("audio", { ref: audio },
            React.createElement("source", { src: music, type: "audio/mp3" })),
        playing ?
            React.createElement(Main, null) :
            React.createElement(Start, { audio: audio, onStart: function () {
                    setPlaying(true);
                } }));
};
